import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { EstadoDocumentoItem, EstadoSolicitudItem, EstadoSolicitudPersonaItem, Roles, SolicitudSeccion, eTypeResult } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { IFilterUsuarioModel } from 'src/app/models/interfaces/seguridad/IFilterUsuarioModel';
import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel';
import { ISolicitudValidarModel } from 'src/app/models/interfaces/solicitud/ISolicitudValidarModel';
import { FilterUsuarioModel } from 'src/app/models/seguridad/FilterUsuarioModel';
import { SolicitudDocumentoModel } from 'src/app/models/solicitud/documento/SolicitudDocumentoModel';
import { SolicitudDocumentoTecnicoValidarModel } from 'src/app/models/solicitud/documento/SolicitudDocumentoTecnicoValidarModel';
import { EquipoModel } from 'src/app/models/solicitud/EquipoModel';
import { PersonalModel } from 'src/app/models/solicitud/PersonalModel';
import { SolicitudDocumentoTecnicoModel } from 'src/app/models/solicitud/SolicitudDocumentoTecnicoModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { SolicitudValidarModel } from 'src/app/models/solicitud/SolicitudValidarModel';
import { VehiculoModel } from 'src/app/models/solicitud/VehiculoModel';
import { UsuarioResultadoBusquedaModel } from 'src/app/models/usuario/UsuarioResultadoBusquedaModel';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { SolicitudDocumentosTecnicosService } from 'src/app/services/solicitud-documentos-tecnicos/solicitud-documentos-tecnicos.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { ValidarEquipoDialogComponent } from '../equipo/validar-equipo-dialog/validar-equipo-dialog.component';
import { ValidarPersonalDialogComponent } from '../personal/validar-personal-dialog/validar-personal-dialog.component';
import { ValidarVehiculoDialogComponent } from '../vehiculo/validar-vehiculo-dialog/validar-vehiculo-dialog.component';
import * as fileSaver from 'file-saver';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { SolicitudPersonaService } from 'src/app/services/solicitud-persona/solicitud-persona.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudEquipoService } from 'src/app/services/solicitud-equipo/solicitud-equipo.service';
import { SolicitudVehiculoService } from 'src/app/services/solicitud-vehiculo/solicitud-vehiculo.service';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';
import { VisorPdfDialogComponent } from '../../shared/visor-pdf-dialog/visor-pdf-dialog.component';

// import { ValidarEquipoDialogComponent } from '../../equipo/validar-equipo-dialog/validar-equipo-dialog.component';
// import { ValidarPersonalDialogComponent } from '../../personal/validar-personal-dialog/validar-personal-dialog.component';
// import { ValidarVehiculoDialogComponent } from '../../vehiculo/validar-vehiculo-dialog/validar-vehiculo-dialog.component';


@Component({
  selector: 'app-solicitud-revisor-validar',
  templateUrl: './solicitud-revisor-validar.component.html',
  styleUrls: ['./solicitud-revisor-validar.component.css']
})
export class SolicitudRevisorValidarComponent implements OnInit {
  public itemSolicitud: ISolicitudModel;
  public model: ISolicitudValidarModel;

  displayedColumnsPersonal: string[] = [
    'nombre',
    'dni',
    'cargo',
    'cantidad_documentos',
    'estado',
    'acciones',
  ];
  displayedColumnsEquipos: string[] = [
    // 'equipo',
    'marca',
    'modelo',
    'serie',
    'estado',
    'acciones',
  ];
  displayedColumnsVehiculos: string[] = [
    'marca',
    'modelo',
    'placa',
    'color',
    'anio',
    'chofer',
    'estado',
    'acciones',
  ];
  displayedColumnsDocumentacionTecnica: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'aprobado',
    'observado',
    'acciones'
  ];

  @ViewChild('tablePersonal', { static: true, read: MatTable })
  tablePersonas!: MatTable<any>;
  @ViewChild('tableEquipos', { static: true, read: MatTable })
  tableEquipos!: MatTable<any>;
  @ViewChild('tableVehiculos', { static: true, read: MatTable })
  tableVehiculos!: MatTable<any>;

  id: number;
  avanceRevisionPersonas: number;
  avanceRevisionEquipos: number;
  avanceRevisionVehiculos: number;
  avanceRevisionDocTecnica: number;
  expandPersonal: boolean = false;
  expandEquipos: boolean = false;
  expandVehiculos: boolean = false;
  expandDocTecnica: boolean = false;
  // listaSupervisores: UsuarioResultadoBusquedaModel[] = new Array<UsuarioResultadoBusquedaModel>();

  constructor(
    private route: ActivatedRoute,
    private solicitudService: SolicitudService,
    private solicitudPersonaService: SolicitudPersonaService,
    private solicitudEquipoService: SolicitudEquipoService,
    private solicitudVehiculoService: SolicitudVehiculoService,
    private solicitudDocumentoTecnicoService: SolicitudDocumentosTecnicosService,
    // private usuarioService: SeguridadUsuarioService,
    public dialog: MatDialog,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private router: Router
  ) {
    this.itemSolicitud = new SolicitudModel();
    this.id = 0;
    this.model = new SolicitudValidarModel();
    this.avanceRevisionPersonas = 0;
    this.avanceRevisionEquipos = 0;
    this.avanceRevisionVehiculos = 0;
    this.avanceRevisionDocTecnica = 0;
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id']; // (+) converts string 'id' to a number
      this.model.idSolicitud = this.id;
      // In a real app: dispatch action to load the details here.
    });

    this.getSolicitud();
  }

  private getSolicitud() {
    this.solicitudService
      .getById(this.id)
      .subscribe((data: ISolicitudModel) => {
        this.itemSolicitud = data;

        this.itemSolicitud.logs = this.itemSolicitud.logs.filter(p => p.comentarios != "" && p.comentarios != null);
        this.itemSolicitud.logsDocumentacionTecnica = this.itemSolicitud.logsDocumentacionTecnica.filter(p => p.comentarios != "");
        this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos = '';

        let totalDocumentos: number = 0;
        let totalDocumentosRevisados: number = 0;
        this.itemSolicitud.personas.forEach((p) => {
          p.documentosRevisados = p.documentos.filter(d => d.idEstado == EstadoDocumentoItem.APROBADO || d.idEstado == EstadoDocumentoItem.OBSERVADO).length;
          totalDocumentosRevisados += p.documentosRevisados;
          totalDocumentos += p.documentos.length;
        });
        this.avanceRevisionPersonas = (totalDocumentosRevisados / totalDocumentos) * 100
        this.expandPersonal = !(totalDocumentos === totalDocumentosRevisados);
        if (this.itemSolicitud.aplicaEquipos) {
          totalDocumentosRevisados = 0;
          totalDocumentos = 0;
          this.itemSolicitud.equipos.forEach((p) => {
            p.documentosRevisados = p.documentos.filter(d => d.idEstado == EstadoDocumentoItem.APROBADO || d.idEstado == EstadoDocumentoItem.OBSERVADO).length;
            totalDocumentosRevisados += p.documentosRevisados;
            totalDocumentos += p.documentos.length;
          });
          this.avanceRevisionEquipos = (totalDocumentosRevisados / totalDocumentos) * 100
          this.expandEquipos = !(totalDocumentos === totalDocumentosRevisados);
        }
        if (this.itemSolicitud.aplicaVehiculos) {
          totalDocumentosRevisados = 0;
          totalDocumentos = 0;
          this.itemSolicitud.vehiculos.forEach((p) => {
            p.documentosRevisados = p.documentos.filter(d => d.idEstado == EstadoDocumentoItem.APROBADO || d.idEstado == EstadoDocumentoItem.OBSERVADO).length;
            totalDocumentosRevisados += p.documentosRevisados;
            totalDocumentos += p.documentos.length;
          });
          this.avanceRevisionVehiculos = (totalDocumentosRevisados / totalDocumentos) * 100
          this.expandVehiculos = !(totalDocumentos === totalDocumentosRevisados);
        }
        if (this.itemSolicitud.aplicaDocumentacionTecnica) {
          totalDocumentosRevisados = this.itemSolicitud.documentosTecnicos.filter(d => d.idEstado == EstadoDocumentoItem.APROBADO).length;
          totalDocumentos = this.itemSolicitud.documentosTecnicos.length;
          this.itemSolicitud.documentosTecnicos.forEach((p) => {
            p.aprobado = p.idEstado === EstadoDocumentoItem.APROBADO;
            p.observado = p.idEstado === EstadoDocumentoItem.OBSERVADO;
          });
          if (totalDocumentos > 0)
            this.avanceRevisionDocTecnica = (totalDocumentosRevisados / totalDocumentos) * 100;
          this.expandDocTecnica = !(totalDocumentos === totalDocumentosRevisados);
        }
        // console.log(this.itemSolicitud);

        // let filterUsuario: IFilterUsuarioModel = new FilterUsuarioModel();
        // filterUsuario.idRol = Roles.SUPERVISOR;
        // filterUsuario.idSede = this.itemSolicitud.idSede;

        // this.usuarioService
        //   .getList(filterUsuario)
        //   .subscribe((data: SearchResultModel<UsuarioResultadoBusquedaModel[]>) => {
        //     this.listaSupervisores = data.items;
        //   });
      });
  }

  openDialogPersonal(personal: PersonalModel): void {
    personal.idSolicitud = this.itemSolicitud.idSolicitud;
    personal.codigoSolicitud = this.itemSolicitud.codigo;

    const dialogRef = this.dialog.open(ValidarPersonalDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: personal,
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result)
        this.getSolicitud();
      // this.solicitudService
      // .getById(this.id)
      // .subscribe((data: ISolicitudModel) => {
      //   this.itemSolicitud = data;
      //   this.tablePersonas.renderRows();
      // });      
    });
  }

  openDialogEquipo(equipo: EquipoModel): void {
    equipo.idSolicitud = this.itemSolicitud.idSolicitud;
    equipo.codigoSolicitud = this.itemSolicitud.codigo;

    const dialogRef = this.dialog.open(ValidarEquipoDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: equipo,
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result)
        this.getSolicitud();
      // this.solicitudService
      // .getById(this.id)
      // .subscribe((data: ISolicitudModel) => {
      //   this.itemSolicitud = data;
      //   this.tableEquipos.renderRows();
      // });
    });
  }

  openDialogVehiculo(vehiculo: VehiculoModel): void {
    vehiculo.idSolicitud = this.itemSolicitud.idSolicitud;
    vehiculo.codigoSolicitud = this.itemSolicitud.codigo;
    const dialogRef = this.dialog.open(ValidarVehiculoDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: vehiculo,
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result)
        this.getSolicitud();
      // this.solicitudService
      // .getById(this.id)
      // .subscribe((data: ISolicitudModel) => {
      //   this.itemSolicitud = data;
      //   this.tableVehiculos.renderRows();
      // });
    });
  }

  EsValido(): boolean {
    return !(
      this.itemSolicitud.personas.filter(p => p.idEstado !== EstadoSolicitudItem.APROBADO).length > 0 ||
      this.itemSolicitud.equipos.filter(p => p.idEstado !== EstadoSolicitudItem.APROBADO).length > 0 ||
      this.itemSolicitud.vehiculos.filter(p => p.idEstado !== EstadoSolicitudItem.APROBADO).length > 0 ||
      this.itemSolicitud.documentosTecnicos.filter(p => p.idEstado !== EstadoSolicitudItem.APROBADO).length > 0
    );
  }

  changeAprobado(element: SolicitudDocumentoTecnicoModel) {
    if (element.aprobado)
      element.observado = false;
  }

  changeObservado(element: SolicitudDocumentoTecnicoModel) {
    if (element.observado)
      element.aprobado = false;
  }

  guardarDocumentosTecnicos(): void {
    let pendientes = this.itemSolicitud.documentosTecnicos.filter(
      (p) => !p.aprobado && !p.observado
    ).length;

    let pendientesObservados = this.itemSolicitud.documentosTecnicos.filter(
      (p) => p.observado
    ).length;

    if (
      pendientes == 0 &&
      pendientesObservados >= 1 &&
      (this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos == '' || !this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos)
    ) {
      this.alertDialogService.open('Debe ingresar un comentario');
    } else {
      let documentosTecnicosModel = new SolicitudDocumentoTecnicoValidarModel();
      documentosTecnicosModel.idSolicitud = this.itemSolicitud.idSolicitud;
      documentosTecnicosModel.comentarios = this.itemSolicitud.comentarioPorValidacionDocumentosTecnicos;

      this.itemSolicitud.documentosTecnicos.forEach(p => {
        let documento = new SolicitudDocumentoModel();
        documento.idDocumento = p.idSolicitudDocumentoTecnico;
        if (p.aprobado) {
          documento.idEstado = EstadoDocumentoItem.APROBADO;
        }
        else if (p.observado) {
          documento.idEstado = EstadoDocumentoItem.OBSERVADO;
        }
        else {
          documento.idEstado = EstadoDocumentoItem.PENDIENTE;
        }

        documentosTecnicosModel.documentos.push(documento);
      });

      this.solicitudDocumentoTecnicoService.validar(documentosTecnicosModel).subscribe((data) => {
        if (pendientes == 0) {
          if (pendientesObservados > 0)
            this.alertDialogService.open('Se registró su observación y se notificó al contratista');
          else
            this.alertDialogService.open('Se registró su aprobación');
          this.alertDialogService.closed().subscribe((confirmed) => {
            this.getSolicitud();
          });
        }
        else
          this.getSolicitud();
      });
    }
  }

  deletePersona(element: PersonalModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud a ${element.nombres} ${element.apellidoPaterno} ${element.apellidoMaterno}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudPersonaService.eliminar(element.idSolicitudPersona).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteEquipo(element: EquipoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el equipo: ${element.equipo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudEquipoService.eliminar(element.idSolicitudEquipo).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteVehiculo(element: VehiculoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el vehículo: ${element.marca}-${element.modelo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudVehiculoService.eliminar(element.idSolicitudVehiculo).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteDocTecnico(element: SolicitudDocumentoTecnicoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el archivo del documento: ${element.documento}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudDocumentoTecnicoService.eliminar(element.idSolicitudDocumentoTecnico).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  downloadDocumentFromService(element: ISolicitudDocumentoTecnicoModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.DocumentacionTecnica;
      modelVisor.idSolicitudDocumento = element.idSolicitudDocumentoTecnico;
      modelVisor.codigoSolicitud = this.itemSolicitud.codigo;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudDocumentoTecnicoService.downloadDocumento(
        this.itemSolicitud.codigo,
        element.idSolicitudDocumentoTecnico
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }
}
